import { useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { useApiData } from 'lib/api';
import { getGroupAdminPermissionOptions } from 'lib/groups';
import { Pagination, User } from 'components/common';
import { Box, BoxRow } from 'components/common/box';
import { OwnersAndAdminsManager } from 'components/common/ownersAndAdmins';
import { StatCount } from 'components/common/stats';

import { GetGroupSupervisorsRes } from 'shared-types/responses';

const GroupAdmins = () => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { group },
    serverConfig: { groupsAllowNonAdminGroupAdmins }
  } = useReduxState();

  const router = useRouter();

  const [page, setPage] = useState(1);

  const { data } = useApiData<GetGroupSupervisorsRes>({
    url: `/admin/groups/${group.id}/supervisors?page=${page}`,
    onlyIf: Boolean(group.id)
  });

  const updateGroup = async () => {
    const groups = await api.get(`/admin/groups?id=${group.id}`);
    if (groups.data.groups.length)
      dispatch(actions.updatePageState({ group: groups.data.groups[0] }));
    else router.push('/groups');
  };

  const adminPermissions = getGroupAdminPermissionOptions({ messages });

  return !group ? null : (
    <div>
      <OwnersAndAdminsManager
        allowNonAdmins={groupsAllowNonAdminGroupAdmins}
        fallbackUrl="/groups"
        permissions={adminPermissions}
        updateProduct={updateGroup}
        url={`/admin/groups/${group.id}/admins`}
      />

      {data?.supervisors?.length ? (
        <div style={{ marginTop: 40 }}>
          <Box
            padding={0}
            title={
              <>
                {messages.adminSupervisors}{' '}
                <StatCount
                  isLarge={true}
                  style={{ display: 'inline-block', marginLeft: 5 }}
                  value={data.numberOfSupervisors}
                />
              </>
            }
          >
            {data.supervisors.map((supervisor) => (
              <BoxRow key={supervisor.id}>
                <User user={supervisor} />
              </BoxRow>
            ))}
          </Box>

          {data?.pages > 1 ? (
            <Pagination
              currentPage={page}
              numberOfPages={data?.pages}
              onPageChange={({ page }) => setPage(page)}
              style={{ marginTop: 15 }}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default GroupAdmins;
